export default __webpack_public_path__ + "static/media/losc.3d01eb27.png";